import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Big3Guide } from './pages/Big3Guide';
import { DailyHoroscope } from './pages/DailyHoroscope';
import { HoroscopeRisingSign } from './pages/HoroscopeRisingSign';
import { ZodiacSignsRisingSign } from './pages/ZodiacSignsRisingSign';
import { FAQ } from './components/FAQ';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/big-3-guide" element={<Big3Guide />} />
          <Route path="/daily-horoscope" element={<DailyHoroscope />} />
          <Route path="/horoscope-rising-sign" element={<HoroscopeRisingSign />} />
          <Route path="/zodiac-signs-rising-sign" element={<ZodiacSignsRisingSign />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </Layout>
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#131722',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.1)',
          },
        }}
      />
    </Router>
  );
}

export default App;
